var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIconWhitecolour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.7885V3.3885L4.28475 5.85375L3.23075 4.76925L7.5 0.5L11.7693 4.76925L10.7153 5.85375L8.25 3.3885V11.7885H6.75ZM1.80775 15.5C1.30258 15.5 0.875 15.325 0.525 14.975C0.175 14.625 0 14.1974 0 13.6923V10.9808H1.5V13.6923C1.5 13.7692 1.53208 13.8398 1.59625 13.9038C1.66025 13.9679 1.73075 14 1.80775 14H13.1923C13.2692 14 13.3398 13.9679 13.4038 13.9038C13.4679 13.8398 13.5 13.7692 13.5 13.6923V10.9808H15V13.6923C15 14.1974 14.825 14.625 14.475 14.975C14.125 15.325 13.6974 15.5 13.1923 15.5H1.80775Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconWhitecolour);
export default __webpack_public_path__ + "static/media/uploadIcon_whitecolour.51ed891ae96f38a79cd4330eae5de034.svg";
export { ForwardRef as ReactComponent };